<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Emergency Contacts"
      text="Update emergency contacts"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localEmergencyContact.name"
                v-validate="'required|max:80|nameAllowedFormat'"
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"  
                outlined
                :class="{
                  'required':!localEmergencyContact.name
                }"
                @input="localEmergencyContact.name = localEmergencyContact.name.toUpperCase()"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localEmergencyContact.relationship_id"
                v-validate="'required'"
                :items="relationships"
                label="Relationship"
                :error-messages="errors.collect('relationship_id')"
                data-vv-name="relationship_id"    
                data-vv-as="relationship"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!localEmergencyContact.relationship_id
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localEmergencyContact.contact_no"
                v-validate="'required'"
                :error-messages="errors.collect('contact_no')"
                data-vv-name="contact_no"                
                data-vv-as="contact no"                
                label="Contact No."
                outlined
                :class="{
                  'required':!localEmergencyContact.contact_no
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      emergencyContact: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localEmergencyContact: null,
        relationships: [],
        loading: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.$validator.extend('nameAllowedFormat', {
          getMessage (field, args) {
            return "Invalid name format. Only alphabet and special character of @ ' * - / . allowed for name"     
          },
          validate (value, args) {
            const regex = /^[ A-Za-z'@./*-]*$/
            return regex.test(value)
          },
        })

        this.loading = true

        this.localEmergencyContact = { ...this.emergencyContact }

        this.$api.hrisRelationships().list()
          .then(res => {
            this.relationships = res.data

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.emergencyContacts().update(this.emergencyContact.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localEmergencyContact.name,
          relationship_id: this.localEmergencyContact.relationship_id,
          contact_no: this.localEmergencyContact.contact_no,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}
</style>
